import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { View, TouchableOpacity, Animated } from 'react-native'
import { Icon, Txt } from '../../../../components'
import { Video } from 'expo-av'
import { useTheme } from '../../../../theming/ThemeProvider'
import { useNavigation } from '@react-navigation/core'

const CollapseCard = ({ question }) => {
  const { title, url } = question
  const [open, setOpen] = useState(false)
  const videoRef = useRef()
  const navigation = useNavigation()
  const _height = url ? 300 : 25

  const animateHeight = useRef(new Animated.Value(0)).current
  const { theme } = useTheme()

  const setCollapse = () => {
    Animated.timing(animateHeight, {
      toValue: open ? 0 : (_height + 20),
      duration: 200,
      useNativeDriver: false
    }).start()
    setOpen(!open)
  }

  useEffect(() => {
    const onBlurListener = navigation.addListener('blur', () => {
      videoRef.current.pauseAsync()
    })

    return onBlurListener
  }, [navigation])

  return (
    <View style={{
      backgroundColor: theme.CARD_BACKGROUND,
      borderRadius: 5,
      marginHorizontal: 10,
      marginBottom: 10,
      padding: 20,
      shadowColor: 'rgba(7, 12, 16, 0.11)',
      shadowOpacity: 0.5,
      shadowRadius: 10,
      elevation: 5
    }}
    >
      <View style={{
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}
      >
        <Txt
          text={title}
          identity='body1'
        />
        <TouchableOpacity
          activeOpacity={0.8} onPress={setCollapse} style={
            { width: 30, height: 30, borderRadius: 100, backgroundColor: theme.GALLERY, justifyContent: 'center', alignItems: 'center' }
          }
        >
          <Icon
            name={open ? 'AngleUp' : 'AngleDown'}
            height={20}
            width={20}
            fill={theme.BUNKER}
          />
        </TouchableOpacity>
      </View>
      <Animated.View style={{ height: animateHeight, overflow: 'hidden' }}>
        {url ? (
          <Video
            ref={videoRef}
            source={{ uri: url }}
            rate={1.0}
            volume={1.0}
            isMuted={false}
            resizeMode='cover'
            shouldPlay={false}
            isLooping={false}
            useNativeControls
            style={{ width: '100%', height: _height, marginTop: 20 }}
          />)
          : (<Txt text='video not available' />)}
      </Animated.View>

    </View>
  )
}

CollapseCard.propTypes = {
  question: PropTypes.object
}

export default CollapseCard
